import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { ThemeService } from './services/theme.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  template: `<main id="main-content"><router-outlet></router-outlet></main>`,
  styles: [`
    :host {
      display: block;
      min-height: 100vh;
    }
    main {
      min-height: 100vh;
    }
  `],
})
export class AppComponent {
  // Wire the document's color-scheme to the server-side preference map
  // (Story 29.2 rework — no device cache). Pre-sign-in the UI follows the
  // system scheme; the operator's stored choice applies when the post-auth
  // preference load lands.
  constructor() {
    inject(ThemeService).init();
  }
}
